import React from 'react';
import { useForm } from 'react-hook-form';
import './Contact.css';

const Contact = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => console.log(data);

  return (
    <div className="contact">
      <h1>Contact & Order</h1>

      <div className="details">
        <p>📍 RDA Colony, Chandni Chowk, Raipur, Chhattisgarh 492001</p>
        <p>📞 08827953485</p>
        <p>🕒 11AM - 11PM</p>
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.0536742217814!2d81.6359277750497!3d21.22972008047039!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28dd00266cdc5b%3A0xb3d38a00eec1c8b8!2sMongnis%20prime%20(cake%20shop)!5e0!3m2!1sen!2sin!4v1766608275541!5m2!1sen!2sin" 
          title="Shop Location">
        </iframe>
      </div>

     
    </div>
  );
};

export default Contact;
